import React from 'react'
import Hero from '../Hero'
import CaseStudies from '../CaseStudies'
import "./Services.css"
import { heroDetails, hireDetails, hireDetailsOne, priceDetails, weOffer } from '../../utils/hire'
import Hire from '../Hire'
import PricingModal from '../PricingModal'
import InterviewForm from '../InterviewForm'
import Experties from '../Experties'
import TopReasons from '../TopReasons'
import WeOffer from '../WeOffer'

function HireDedicatedDevelopers() {

  console.log(hireDetailsOne)

  return (
    <section className='services'>
    <Hero {...heroDetails}/>
    {/* <InterviewForm/> */}
    <Experties/>
    <Hire {...hireDetailsOne}/>
    <TopReasons/>
  {/* <CaseStudies/> */}
  {/* <div className='padding'>
  <Hire {...hireDetails}/>
  </div> */}
  {/* <div className='padding'>
  <PricingModal priceDetails={priceDetails}/>
  </div> */}
  <WeOffer data={weOffer}/> 
  </section>

  )
}

export default HireDedicatedDevelopers